import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicModalComponent } from './dynamic-modal/dynamic-modal.component';
import { DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxDateBoxModule, DxNumberBoxModule, DxPopupModule, DxRadioGroupModule, DxScrollViewModule, DxSelectBoxModule, DxTagBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { MdbGlobalModule } from '../mdb-global.module';


@NgModule({
  declarations: [DynamicModalComponent],
  exports:[
    DynamicModalComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxPopupModule,
    DxButtonModule, 
    DxTagBoxModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxDataGridModule, 
    DxSelectBoxModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    DxNumberBoxModule,
    DxRadioGroupModule,
  ]
})
export class DynamicModal2Module { }
